// Lê o blob como ArrayBuffer e devolve o SHA-256 em hexadecimal. Esse hash
// precisa coincidir, byte a byte, com o que o backend recalcula sobre os bytes
// recebidos — por isso vem do próprio blob exibido ao cliente, nunca de uma
// re-geração do PDF.
export const computePdfSha256 = async (blob) => {
  const buffer = await blob.arrayBuffer();
  const hash_buffer = await window.crypto.subtle.digest('SHA-256', buffer);
  const hash_bytes = Array.from(new Uint8Array(hash_buffer));
  return hash_bytes.map((b) => b.toString(16).padStart(2, '0')).join('');
};

export const blobToBase64 = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onloadend = () => {
    // readAsDataURL devolve "data:<mime>;base64,<payload>" — só o payload
    // vai para o backend; o prefixo é descartado.
    const payload = String(reader.result).split(',')[1] || '';
    resolve(payload);
  };
  reader.onerror = reject;
  reader.readAsDataURL(blob);
});
